import type { FC } from "react";

import { TypeToConfirmDialog } from "@/components/form";

import type { CaseSettingsForm } from "../useCaseSettingsForm";

/** Type-the-last-name confirmation before a case is deleted. */
export const DeleteCaseDialog: FC<{ form: CaseSettingsForm }> = ({ form }) => (
  <TypeToConfirmDialog
    open={form.isDeleteOpen}
    onOpenChange={(open) => {
      if (!open) form.closeDeleteDialog();
    }}
    title="Delete case?"
    description={
      <>
        This will delete{" "}
        <span className="font-medium text-foreground">
          {form.individualDisplayName || "this matter"}
        </span>
        . This action cannot be undone.
      </>
    }
    expected={form.expectedLastName}
    expectedNoun="last name"
    missingExpectedMessage="This individual is missing a last name, so deletion can't be confirmed."
    isPending={form.isDeleting}
    onConfirm={() => {
      form.handleDeleteMatter().catch(() => undefined);
    }}
  />
);
